import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import Helper from "src/utils/helper";
import DBOperationsComb from "src/utils/dbOperationsComb";

async function getBladesShops(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.BLADES_SHOPS_TABLE,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getBladesUnits(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.BLADES_UNITS_TABLE,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getBladesUnitsWithChangeInfo(shopIds) {
  try {
    return await DBOperationsComb.useSupabaseRPC(
      Constants.enums.DATABASE_FUNCTION_ENUM.GET_BLADES_UNITS_WITH_CHANGE_INFO,
      {
        p_shop_ids: shopIds
      }
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getBladeEventDetails(eventId) {
  try {
    return await DBOperationsComb.useSupabaseRPC(
      Constants.enums.DATABASE_FUNCTION_ENUM.GET_BLADE_EVENT_DETAILS,
      {
        p_event_id: eventId
      }
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getRowBladeEventDetails(eventId, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.BLADES_EVENT_DETAILS_TABLE,
        fetchDeleted: false,
        fetchAll: true,
        queryParams: [
          {
            field: "event_id",
            value: eventId
          }
        ]
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function insertBladeEventDetails(data, offlineFirst = false) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.BLADES_EVENT_DETAILS_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function updateBladeEventDetails(data, offlineFirst = false) {
  try {
    return await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.BLADES_EVENT_DETAILS_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateBladesUnit(data, offlineFirst = false) {
  try {
    return await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.BLADES_UNITS_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function insertBladeEvent(data, offlineFirst = false) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.BLADES_EVENTS_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

/**
 * Reverts a blade change event by:
 * 1. Marking the original event as reverted
 * 2. Creating a new revert event record
 * 3. Copying all blade event details to the new revert event
 */
async function revertBladeEvent(data, offlineFirst = false) {
  try {
    // Step 1: Mark the original event as reverted
    const updateResponse = await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.BLADES_EVENTS_TABLE,
      {
        id: data.id,
        is_reverted: true
      },
      offlineFirst
    );

    if (updateResponse?.error) {
      throw new Error(updateResponse.error);
    }

    // // Step 2: Create a new revert event record linked to the original event
    // const revertEventData = {
    //   event_type: "blade_change_revert",
    //   shop_id: data.shop_id,
    //   unit_id: data.unit_id,
    //   changed_on: data.changed_on,
    //   hr_read: data.hr_read,
    //   km_read: data.km_read,
    //   comments: data.comments,
    //   change_reason: data.change_reason,
    //   parent_id: data.id, // Link to original event
    //   early_blade_change: data.early_blade_change,
    //   early_blade_change_comment: data.early_blade_change_comment,
    //   is_unit_shop_mis_aligned: data.is_unit_shop_mis_aligned,
    //   created_by_user_name: Helper.getUserName(),
    //   created_by_user_email: Helper.getUserEmail(),
    //   is_reverted: false
    // };

    // const revertEventResponse = await insertBladeEvent(revertEventData, offlineFirst);

    // if (revertEventResponse?.error) {
    //   throw new Error(revertEventResponse.error);
    // }

    // Step 3: Fetch all blade event details from the original event
    const originalEventDetailsResponse = await getRowBladeEventDetails(
      data.id,
      offlineFirst
    );

    if (originalEventDetailsResponse?.error) {
      throw new Error(originalEventDetailsResponse.error);
    }

    // Step 4: Copy all blade event details to the new revert event
    if (originalEventDetailsResponse?.data && Array.isArray(originalEventDetailsResponse.data)) {
      for (const detail of originalEventDetailsResponse.data) {
        const revertDetailData = {
          id: detail.id,
          is_reverted: true
        };

        // await insertBladeEventDetails(revertDetailData, offlineFirst);
        await updateBladeEventDetails(revertDetailData, offlineFirst);
      }
    }
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getBladeEventsForUnit(config = {}, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.BLADES_EVENTS_TABLE,
        fetchDeleted: false,
        fetchAll: true,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getBladesInventoryView(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.BLADES_INVENTORY_VIEW_TABLE,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getBladesInventoryReconciliationDiscrepancies() {
  try {
    return await DBOperationsComb.useSupabaseRPC(
      Constants.enums.DATABASE_FUNCTION_ENUM.BLADES_INVENTORY_RECONCILIATION_DISCREPANCIES,
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getBladesInventory(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.BLADES_INVENTORY_TABLE,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
// this is adhoc update to the blades inventory table
async function addBladesAdjustmentDetails(data, offlineFirst = false) {
  try {
    console.log("data :", data);
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.BLADES_ADJUSTMENT_DETAILS_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
export default {
  getBladesShops,
  getBladesUnits,
  updateBladesUnit,
  insertBladeEvent,
  revertBladeEvent,
  getBladeEventsForUnit,
  getBladesInventoryView,
  getBladesInventoryReconciliationDiscrepancies,
  getBladesInventory,
  addBladesAdjustmentDetails,
  getBladesUnitsWithChangeInfo,
  getBladeEventDetails
};
